import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-button-with-dropdown',
  templateUrl: './button-with-dropdown.component.html',
  styleUrls: ['./button-with-dropdown.component.scss'],
})
export class ButtonWithDropdownComponent implements OnInit {
  @ViewChild('content') content: any;

  @Input() label: string = 'click';
  @Input() showOptions: boolean = false;
  @Input() outline: boolean = false;
  @Input() haveIcon: boolean = false;
  @Input() iconSrc: string = '';
  @Input() disabled: boolean = false;

  @Output() onClick = new EventEmitter<MouseEvent>();
  @Output() toggleShowOptions = new EventEmitter<MouseEvent>();

  constructor(
    private cdRef: ChangeDetectorRef,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.showOptions && !this.elementRef.nativeElement.contains(event.target)) {
      this.toggleShowOptions.emit(event);
    }
  }

  click(event: MouseEvent) {
    event.stopPropagation(); // Prevenir que o listener da janela interfira
    if (!this.disabled) {
      this.onClick.emit(event);
    }
  }

  handleShowOptions(event) {
    event.stopPropagation(); // Prevenir que o listener da janela interfira
    if (this.disabled) {
      return; // Não permite abrir dropdown se estiver desabilitado
    }
    this.toggleShowOptions.emit(event);
  }
}
